var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.ehUsuarioCliente && _vm.canAccessDashCliente)?_c('dashboard-cliente'):_c('dashboard-funcionario-industria')],1)}
var staticRenderFns = []

export { render, staticRenderFns }